(function () {
    function init(el) {
        var track = el.querySelector('.rcatc-video-reel__track');
        var backdrop = el.querySelector('.rcatc-video-reel__modal-backdrop');
        var iframe = el.querySelector('.rcatc-video-reel__iframe');
        var modalTitle = el.querySelector('.rcatc-video-reel__modal-title');
        var modalChannel = el.querySelector('.rcatc-video-reel__modal-channel');

        function openModal(videoId, title, channel) {
            track.classList.add('is-paused');
            backdrop.classList.add('is-open');
            backdrop.setAttribute('aria-hidden', 'false');
            iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1';
            modalTitle.textContent = title;
            modalChannel.textContent = channel;
        }

        function closeModal() {
            backdrop.classList.remove('is-open');
            backdrop.setAttribute('aria-hidden', 'true');
            iframe.src = '';
            track.classList.remove('is-paused');
        }

        el.querySelectorAll('.rcatc-video-reel__card').forEach(function (card) {
            card.addEventListener('click', function () {
                openModal(
                    card.dataset.videoId,
                    card.dataset.title,
                    card.dataset.channel
                );
            });
        });

        el.querySelector('.rcatc-video-reel__modal-close')
            .addEventListener('click', closeModal);

        backdrop.addEventListener('click', function (e) {
            if (e.target === backdrop) closeModal();
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && backdrop.classList.contains('is-open')) {
                closeModal();
            }
        });

        // Carousel — tablet/mobile only (desktop uses ticker above)
        var carouselWrap = el.querySelector('.rcatc-video-reel__carousel-wrap');
        var prevBtn      = el.querySelector('.rcatc-video-reel__carousel-prev');
        var nextBtn      = el.querySelector('.rcatc-video-reel__carousel-next');
        var dotsEl       = el.querySelector('.rcatc-video-reel__dots');
        // Only first-pass cards (not duplicates) — duplicates carry aria-hidden="true"
        var cards        = Array.from(el.querySelectorAll('.rcatc-video-reel__card:not([aria-hidden])'));

        var currentPage  = 0;
        var cardsPerPage = 1;
        var totalPages   = 1;
        var isCarousel   = false;

        function getCardsPerPage() {
            return window.innerWidth <= 767 ? 1 : 3;
        }

        function buildDots() {
            dotsEl.innerHTML = '';
            for (var i = 0; i < totalPages; i++) {
                var dot = document.createElement('span');
                dot.className = 'rcatc-video-reel__dot' + (i === currentPage ? ' is-active' : '');
                (function (page) {
                    dot.addEventListener('click', function () { goToPage(page); });
                }(i));
                dotsEl.appendChild(dot);
            }
        }

        function goToPage(page) {
            currentPage = ((page % totalPages) + totalPages) % totalPages;
            // Use pixel offset so any CSS gap between cards is accounted for exactly.
            var cardWidth = cards[0] ? cards[0].offsetWidth : 0;
            var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
            track.style.transform = 'translateX(-' + (currentPage * cardsPerPage * (cardWidth + gap)) + 'px)';
            dotsEl.querySelectorAll('.rcatc-video-reel__dot').forEach(function (d, i) {
                d.classList.toggle('is-active', i === currentPage);
            });
        }

        function enterCarousel() {
            isCarousel   = true;
            cardsPerPage = getCardsPerPage();
            totalPages   = Math.ceil(cards.length / cardsPerPage);
            currentPage  = 0;
            el.classList.add('is-carousel');
            el.classList.remove('is-ticker');
            track.classList.remove('is-paused');
            buildDots();
            goToPage(0);
        }

        function enterTicker() {
            isCarousel = false;
            el.classList.add('is-ticker');
            el.classList.remove('is-carousel');
            track.style.transform = '';
            dotsEl.innerHTML      = '';
        }

        function checkMode() {
            var shouldBeCarousel = window.innerWidth <= 1024;
            if (shouldBeCarousel && !isCarousel) {
                enterCarousel();
            } else if (!shouldBeCarousel && isCarousel) {
                enterTicker();
            } else if (shouldBeCarousel) {
                // Already in carousel — recheck cards-per-page (may have crossed 767px)
                var newCpp = getCardsPerPage();
                if (newCpp !== cardsPerPage) enterCarousel();
            }
        }

        prevBtn.addEventListener('click', function () { if (isCarousel) goToPage(currentPage - 1); });
        nextBtn.addEventListener('click', function () { if (isCarousel) goToPage(currentPage + 1); });

        // Touch swipe
        var touchStartX = 0;
        el.addEventListener('touchstart', function (e) {
            touchStartX = e.changedTouches[0].clientX;
        }, { passive: true });
        el.addEventListener('touchend', function (e) {
            if (!isCarousel) return;
            var delta = e.changedTouches[0].clientX - touchStartX;
            if (Math.abs(delta) > 50) goToPage(currentPage + (delta < 0 ? 1 : -1));
        });

        // Debounced resize
        var resizeTimer;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(checkMode, 100);
        });

        // Init
        checkMode();
    }

    document.querySelectorAll('.rcatc-video-reel').forEach(init);
})();
